<template>
  <div>
    <v-card class="rounded-lg" elevation="0">
      <section class="header-table">
        <v-text-field
          v-model="search1"
          clearable
          class="rounded-lg"
          append-icon="mdi-magnify"
          label="Múnicipios..."
          @keyup.enter="searchRegister"
          single-line
          hide-details
          outlined
          dense
        ></v-text-field>
        <div class="space"></div>
        <v-select
          dense
          outlined
          v-model="HealthRegion"
          :items="HealthRegionList"
          @keyup.enter="searchRegister"
          clearable
          item-text="name"
          item-value="id"
          label="Região de saúde"
        ></v-select>
        <div class="space"></div>
        <v-select
          dense
          outlined
          clearable
          v-model="regional_nucleus_health_id"
          :items="regionalNucleusHealthList"
          @keyup.enter="searchRegister"
          item-text="name"
          item-value="id"
          label="Macrorregião"
        ></v-select>
        <div class="space"></div>
        <v-btn
          class="rounded-lg"
          elevation="0"
          color="success"
          @click="searchRegister"
        >
          <v-icon small class="mr-2" color="#FFFFFF"> mdi-magnify </v-icon>
          <span class="textBtn"> Pesquisar </span>
        </v-btn>
        <div class="space"></div>
        <v-btn
          class="rounded-lg"
          elevation="0"
          color="primary"
          :disabled="disabledItensByProfile"
          @click="dialog = true"
        >
          <v-icon small class="mr-2" color="#FFFFFF"> mdi-plus </v-icon>
          <span class="textBtn"> Novo </span>
        </v-btn>
        <div class="space"></div>
        <v-btn
          class="rounded-lg"
          elevation="0"
          color="#C62828"
          @click="clearSearch"
        >
          <span class="textBtn"> LIMPAR</span>
        </v-btn>
      </section>

      <v-data-table
        :headers="headers"
        :items="CountyList"
        :footer-props="{
          'items-per-page-text': 'Registros por Página',
        }"
        :page="page"
        :pageCount="numberOfPages"
        :options.sync="options"
        :sort-by.sync="sortBy"
        :server-items-length="TotalResgister"
        :loading="loading"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <Crud :resource="item" v-on:eventname="crudUser" />
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" width="600px" persistent>
        <v-card class="create-user-dialog rounded-lg">
          <div class="banner">
            <h4>Criar Município</h4>
          </div>

          <AlertError
            class="mb-5"
            v-model="displayError"
            :resource="displayError"
          />

          <v-form @submit.prevent="create" ref="form">
            <v-text-field
              class="rounded-lg"
              label="Nome do Município"
              placeholder="Município"
              outlined
              v-model="name"
              :rules="nameRules"
              dense
            ></v-text-field>

            <v-text-field
              class="rounded-lg"
              label="Ibge"
              placeholder="IBGE"
              v-mask="'######'"
              outlined
              v-model="ibge"
              :rules="nameRules"
              dense
            ></v-text-field>

            <v-text-field
              class="rounded-lg"
              label="população"
              placeholder="População"
              outlined
              v-model="population"
              :rules="nameRules"
              dense
            ></v-text-field>

            <v-select
              dense
              outlined
              v-model="HealthRegion"
              :items="HealthRegionList"
              :rules="nameRules"
              item-text="name"
              item-value="id"
              label="Região de saúde"
            ></v-select>

            <v-card-actions class="cardFooter">
              <v-spacer></v-spacer>

              <v-btn
                class="rounded-lg"
                color="#e74c3c"
                text
                elevation="0"
                @click="dialog = false"
              >
                <span>Cancelar</span>
              </v-btn>

              <v-btn
                class="rounded-lg"
                elevation="0"
                color="#27ae60"
                type="submit"
              >
                <span class="textBtn">Enviar dados</span>
                <v-icon color="#FFFFFF" small class="ml-2"
                  >mdi-arrow-right</v-icon
                >
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-card>

    <v-snackbar v-model="snackbar">
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "@/axios";
import Crud from "./CrudCounty-comp.vue";
import AlertError from "../alerts/Error-component.vue";

export default {
  data() {
    return {
      dialog: false,
      search: "",
      search1: "",
      search2: "",
      search3: "",
      headers: [
        { text: "Ações", value: "actions", sortable: false, width: "20%" },
        {
          text: "Múnicipios",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "Região Saúde",
          align: "start",
          value: "health_region.name",
          sortable: false,
        },
        {
          text: "Macrorregião",
          align: "start",
          value: "health_region.regional_nucleus_heath.name",
          sortable: false,
        },
      ],

      nameRules: [(v) => !!v || "O campo é obrigatório"],

      displayError: {
        display: false,
        message: [],
      },

      page: 1,
      numberOfPages: 0,
      passengers: [],
      loading: true,
      options: {},
      sortBy: "name",

      CountyList: [],
      County: "",
      HealthRegionList: [],
      TotalResgister: 0,
      regionalNucleusHealthList: [],
      regional_nucleus_health_id: "",

      message: "",
      snackbar: false,
      loadingBTN: false,
      exibirMensagem: false,
      messageError: "",

      name: "",
      ibge: "",
      population: "",
      HealthRegion: "",
      disabledItensByProfile: false,
    };
  },

  components: {
    Crud,
    AlertError,
  },

  watch: {
    sortBy: {
      handler() {
        console.log(this.sortBy);
      },
    },
    options: {
      handler() {
        this.indoDataTable();
      },
    },
    deep: true,
  },

  methods: {
    resetForm() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    loadSelects() {
      axios.get(`/health-region`).then((response) => {
        this.HealthRegionList = response.data;
      });

      axios.get(`/regional-nucleus-health/`).then((response) => {
        this.regionalNucleusHealthList = response.data;
      });
    },
    searchRegister() {
      this.loading = true;
      const { page } = this.options;
      let pageNumber = page;
      let data = new Object();
      data.per_page = this.options.itemsPerPage;

      axios
        .get(
          `/county?page=${pageNumber}&per_page=${data.per_page}&name=${this.search1}&regional_nucleus_health_id=${this.regional_nucleus_health_id}&health_region_id=${this.HealthRegion}`
        )
        .then((response) => {
          this.loading = false;
          this.CountyList = response.data.data;
          this.TotalResgister = response.data.total;
          this.numberOfPages = response.data.last_page;
        });
    },

    indoDataTable() {
      this.loading = true;
      const { page } = this.options;
      let pageNumber = page;
      let data = new Object();
      data.per_page = this.options.itemsPerPage;

      axios
        .get(
          `/county?page=${pageNumber}&per_page=${data.per_page}&name=${this.search1}&regional_nucleus_health_id=${this.regional_nucleus_health_id}&health_region_id=${this.HealthRegion}`
        )
        .then((response) => {
          this.loading = false;
          this.CountyList = response.data.data;
          this.TotalResgister = response.data.total;
          this.numberOfPages = response.data.last_page;
        });
    },

    create() {
      if (this.$refs.form.validate() == true) {
        const dados = new Object();
        dados.name = this.name;
        dados.health_region_id = this.HealthRegion;
        dados.population = this.population;
        dados.ibge = this.ibge;

        axios
          .post(`/county`, dados)
          .then((response) => {
            this.indoDataTable();
            this.resetForm();
            this.message = response.data.message;
            this.snackbar = true;
            this.dialog = false;
          })
          .catch((err) => {
            err;
            var error = "";
            Object.values(this.$store.state.errorMessage).map((value) => {
              error = value;
            });

            this.displayError.message = error.toString();
            this.displayError.display = true;
            setTimeout(() => {
              this.displayError.display = false;
            }, 3000);
          });
      }
    },

    crudUser(resource) {
      if (resource != "") {
        axios.delete(`/county/${resource}`).then((response) => {
          this.indoDataTable();
          this.message = response.data.message;
          this.snackbar = true;
        });
        return;
      }

      this.indoDataTable();
    },

    clearSearch() {
      (this.search1 = ""),
        (this.HealthRegion = ""),
        (this.regional_nucleus_health_id = "");
      this.indoDataTable();
    },
  },

  mounted() {
    if(this.$store.state.profile_id == 2){
      this.disabledItensByProfile = true;
    }
    this.indoDataTable();
    this.loadSelects();
  },

  // computed: {
  //   filteredItems() {
  //     return this.CountyList.filter((item) => {
  //       return (
  //         item.name.toLowerCase().includes(this.search1.toLowerCase()) &&
  //         item.health_region.name
  //           .toLowerCase()
  //           .toString()
  //           .includes(this.search2) &&
  //         item.health_region.regional_nucleus_heath.name
  //           .toLowerCase()
  //           .includes(this.search3.toLowerCase())
  //       );
  //     });
  //   },
  // },
};
</script>

<style scoped>
.header-table {
  display: flex;
  margin-bottom: 20px;
}

.space {
  width: 15px;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #27ae60, #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #27ae60, #1abc9c);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner > h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
